import React from "react";
import { Form, notification, Spin } from "antd";
import "./Downtime.css";
import { DowntimeFormLabels, access_capabilities } from "../../../Utils/constants";
import DowntimeForm from "../../BasicFormItem/DowntimeForm";
import ButtonComp from "../../ButtonComp/ButtonComp";
import { CheckCircleOutlined } from "@ant-design/icons";
import { DowntimeVar } from "../../../Utils/variables";
import { useDispatch, useSelector } from "react-redux";
//import { onDowntimeSubmit } from "../../../API-Interaction/apiServices/plants.api";
import { getAllPlants } from '../../../API-Interaction/apiServices/plants.api';

import { onDowntimeValuesSubmit } from "../../../API-Interaction/apiServices/productionLine.api";
import moment from "moment";
import { antIcon, canPerformAction } from "../../../Helpers/helpers";

const { heading } = DowntimeVar

const Downtime = () => {
  const { current = null} = useSelector(state => state.plant)
  const [form] = Form.useForm();
  const { pageLoaders } = useSelector(state => state?.utils.loaders)
  const selector = useSelector(state => state)
  let { plant = null,machine = null,line = null } = useSelector(state => state?.plant?.current)
  //console.log(plant)

  form.setFieldsValue({
    calculation: machine?.stopTime?.downtime || line?.stopTime?.downtime || 0,
    reason: machine?.stopTime?.reason || line?.stopTime?.reason || 0,
    disconnect: machine?.stopTime?.disconnectChecker || line?.stopTime?.disconnectChecker || 0,
})
  const formTailLayout = {
    labelCol: {
      span: 8,
    },
    wrapperCol: {
      span: 12,
    },
  };

  let dispatch = useDispatch()
  const onSubmitSC = (values) => {
    let downtime = {
      downtime:values.calculation,
      reason:values.reason,
      disconnectChecker:values.disconnect
    }
    let updatedLog = null
    let {plant = null, machine = null,line=null} = JSON.parse(localStorage.getItem('current'));

    if(machine){
      let productionLine = line;
      for(let x = 0;x<(productionLine.machines).length;x++){
        if(productionLine.machines[x].machineName == machine.machineName)
        {
            
        productionLine.machines[x]['stopTime'] = downtime;
        ////(productionLine.machines[x].shifts).push(values);
        }
    }
     //let machines  = line.machines
     //machines[machine.machineName] = {...machines[machine.machineName],stopTime:downtime}
     updatedLog = productionLine; 
    }
    else{
      updatedLog = {stopTime:downtime}
    }
    let body = {
      plantId:plant?._id,
      updatedAt: `${moment(Date.now()).format(`${"YYYY-MM-DDThh:mm:ss.ms"}`)}Z`,
      _id: line?._id,
      ...updatedLog
    }
    onDowntimeValuesSubmit(dispatch, body)
    
    getAllPlants(dispatch, selector)
  }
  return (
    <Spin indicator={antIcon} spinning={pageLoaders?.downtime ? pageLoaders?.downtime : false}>

      <div className="dflex flexColumn gap20">
        <h1 className="pageHead">{heading}</h1>
        <div className="width100P">
          <Form
            onFinish={onSubmitSC}
            form={form}
            onFinishFailed={(error) => console.log(error)}
            name="basic" layout="vertical">

            {DowntimeFormLabels.map((items, index) => (
              <>
              <DowntimeForm key={index} props={items} />
              </>
            ))}
            {/* {canPerformAction(current, access_capabilities.canEditLineSettings) && ( */}
            <Form.Item {...formTailLayout}>
              <div className="form-button-div">
                <ButtonComp
                  theme="blue"
                  hmtlType="submit"
                  text="Save"
                  icon={<CheckCircleOutlined />}
                />
              </div>
            </Form.Item>
            {/* )} */}
          </Form>
        </div>
      </div>
    </Spin>
  );
};

export default Downtime;
